<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-31 16:17:11
 * @FilePath: 
 * @Description: 解锁商户
-->
<template>
  <div class="full_page unlock_page">
    <div class="store_logo_con">解 锁</div>
    <div class="register_form_con">
      <van-form @submit="onSubmit">
        <van-field
          v-model="formData.Phone"
          type="tel"
          name="Phone"
          maxlength="11"
          label="手机号"
          placeholder="请输入手机号"
          :error="false"
          :rules="[{ required: true, message: '请输入手机号' }]"
        >
        </van-field>

        <div style="margin: 36px 0">
          <van-button
            block
            color="var(--tc)"
            native-type="submit"
            :loading="isSubmiting"
            loading-text="解锁中..."
            >解锁</van-button
          >
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { unlockTenant } from "@/api/equip";
export default {
  name: "UnlockTenant",
  props: {},
  data() {
    return {
      // logoImgUrl: "",
      formData: {
        Phone: "",
      },
      isSubmiting: false,
    };
  },
  components: {},
  created() {},
  mounted() {
    // const vpnInfo = this.$store.state.vpnInfo;
    // console.log(this.$store);
    // const imgArr = vpnInfo.Claims;
    // if (imgArr instanceof Array && imgArr.length > 0) {
    //   const imgItem = imgArr.find((subItem) => subItem.TypeId === 2);
    //   if (imgItem) {
    //     this.logoImgUrl = `${imgItem.CdnUrl}/${imgItem.Value}`;
    //   }
    // }
  },
  methods: {
    onSubmit(values) {
      console.log("submit", values);
      this.isSubmiting = true;
      unlockTenant(values)
        .then((res) => {
          this.isSubmiting = false;
          this.$toast("解锁成功");
        })
        .catch(() => {
          this.isSubmiting = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
.unlock_page {
  background: linear-gradient(180deg, #f4f3f0 0%, #fff 100%);
  padding-top: 1px;
  display: flex;
  flex-direction: column;
  .store_logo_con {
    margin: 290px 135px 100px;
    text-align: center;
    font-weight: bold;
    font-size: 40px;
    color: #333;
  }
  .register_form_con {
    padding: 0 30px 200px;
  }
}
</style>
